import { MutableRefObject } from 'react';
import { usePushdownContext } from '../../../../../../../../providers/Pushdown/PushdownProvider';
import { ISubmitResponse } from '../../../../../../../../types/shared/PrequalificationDataEntry';
import SessionStorage from '../../../../../../../../utils/SessionStorage';
import { useLoader } from '../../../../../../providers/LoaderProvider';
import { usePageProperties } from '../../../../../../providers/PagePropertiesProvider';
import useHandleError from './useHandleError';
import useSubmitResponseValidation from './useSubmitResponseValidation';

export default function usePrequalError() {
    const { apiResponseErrorCode } = usePageProperties();
    const { showPushdown } = usePushdownContext();
    const { setShouldRenderLoader } = useLoader();
    const { handleSubmitError } = useHandleError();
    const { handleValidationFromApi } = useSubmitResponseValidation();

    const errorFlow = (
        data: ISubmitResponse,
        submittingStateRef: MutableRefObject<boolean>,
    ) => {
        try {
            handleValidationFromApi(data.Errors);
            handleSubmitError(submittingStateRef)(data);
        } catch (error) {
            console.error('Error occurred in the API but no reason was given');
            showPushdown(apiResponseErrorCode ?? 'processingError');
        }

        SessionStorage.remove('prequalResponse');
        setShouldRenderLoader(false);
    };

    return {
        errorFlow,
    };
}
